module.exports = __webpack_public_path__ + "img/partner19.e841ddbb.jpg";